import PropTypes from "prop-types";
import React from "react";
import ImmutablePropTypes from "react-immutable-proptypes";

import withScrollableView from "../../components/scrollable/withScrollableView";

const NarrativeSyncScroller = props => {
  return <div className="narrativeSyncScroller">{props.children}</div>;
};

NarrativeSyncScroller.propTypes = {
  // Any special instructions when placing the data?
  children: PropTypes.element,
  viewIds: ImmutablePropTypes.listOf(PropTypes.string).isRequired,

  // Also accessed by ScrollableView
  requestViewBoundsForZoom: PropTypes.func.isRequired
};

const scrollableViewOptions = {
  scrollHorizontally: true,
  scrollVertically: false,
  showHorizontalScrollbar: true,
  horizontalIsInfinite: false
};

export default withScrollableView(NarrativeSyncScroller, scrollableViewOptions);
